<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow
    :class="b()"
    title="Подтверждение вывода через email"
    :is-big="true"
    @close="handleClose"
  >
    <div :class="b('wrapper')">
      <p :class="b('label')">
        {{ $t("Проверьте данные для перевода:") }}
      </p>

      <p :class="b('label')">{{ $t("Кошелек:") }}</p>

      <b :class="b('label', { withdraw: true })">{{ modal.address }}</b>

      <p :class="b('label')">
        {{ $t("Сеть:")
        }}<b :class="b('label', { withdraw: true })">{{ modal.network }}</b>
      </p>

      <p :class="b('label')">
        {{ $t("Сумма:")
        }}<b :class="b('label', { withdraw: true })">{{ modal.amount }}</b>
        <b :class="b('label', { withdraw: true })">{{ modal.currencyName }}</b>
      </p>

      <p :class="b('label')">
        {{ $t("Вы получите")
        }}<b :class="b('label', { withdraw: true })">{{ modal.total }}</b>
        <b :class="b('label', { withdraw: true })">{{ modal.currencyName }}</b>
      </p>

      <p :class="b('label')">
        {{ $t("Код-подтверждение отправлен на email") }}
      </p>

      <SharedVerification
        :class="b('verification')"
        label="Введите 6 цифр из сообщения на email"
        v-model:code="code"
        :is-error="false"
      />

      <p :class="b('error')" v-if="displayedErrorMessage">
        {{ displayedErrorMessage }}
      </p>

      <UIButton
        label="Подтвердить"
        view="main"
        :disabled="isConfirmDisabled"
        @click="handleVerification"
      />
    </div>
  </SharedWindow>
</template>
